(() => {
  'use strict';

  const isGerman = (document.documentElement.lang || '').toLowerCase().startsWith('de');
  const germanConsentCopy = 'Mit Zustimmung nutzen wir und Shopify Cookies für Analyse, Personalisierung und Marketing. Mehr: Datenschutzerklärung.';
  let observedBanner = null;
  let bannerContentObserver = null;

  function observeBannerContent(banner) {
    if (observedBanner === banner) return;

    if (bannerContentObserver) bannerContentObserver.disconnect();
    observedBanner = banner;
    bannerContentObserver = new MutationObserver(enhanceBanner);
    bannerContentObserver.observe(banner, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  function syncBannerVisibility(banner) {
    const isVisible = Boolean(
      banner
      && window.getComputedStyle(banner).display !== 'none'
      && banner.getClientRects().length > 0
    );
    document.documentElement.toggleAttribute('data-asif-consent-banner-visible', isVisible);
  }

  function enhanceBanner() {
    const banner = document.getElementById('shopify-pc__banner');

    if (banner) {
      observeBannerContent(banner);
      banner.dataset.asifEnhanced = 'true';

      const accept = document.getElementById('shopify-pc__banner__btn-accept');
      const decline = document.getElementById('shopify-pc__banner__btn-decline');
      const manage = document.getElementById('shopify-pc__banner__btn-manage-prefs');

      if (isGerman) {
        const title = banner.querySelector('.shopify-pc__banner__body h2');
        const paragraph = banner.querySelector('.shopify-pc__banner__body p');
        const policyLink = document.getElementById('shopify-pc__banner__body-policy-link');

        if (title && title.textContent !== 'Cookies. Kurz und klar.') title.textContent = 'Cookies. Kurz und klar.';
        if (paragraph && policyLink && paragraph.textContent.trim() !== germanConsentCopy) {
          policyLink.textContent = 'Datenschutzerklärung';
          paragraph.replaceChildren(
            document.createTextNode('Mit Zustimmung nutzen wir und Shopify Cookies für Analyse, Personalisierung und Marketing. Mehr: '),
            policyLink,
            document.createTextNode('.')
          );
        }

        if (accept && accept.textContent !== 'Alle akzeptieren') accept.textContent = 'Alle akzeptieren';
        if (decline && decline.textContent !== 'Nur notwendige') decline.textContent = 'Nur notwendige';
        if (manage) {
          const label = manage.querySelector('span') || manage;
          if (label.textContent !== 'Einstellungen') label.textContent = 'Einstellungen';
        }
      }

      // Shopify owns the button nodes and their event handlers. Keep the DOM
      // intact and use CSS only for the visual hierarchy.
    }

    const preferences = document.getElementById('shopify-pc__prefs__dialog');
    if (preferences && preferences.dataset.asifEnhanced !== 'true') {
      preferences.dataset.asifEnhanced = 'true';

      const close = document.getElementById('shopify-pc__prefs__header-close');
      if (isGerman) {
        if (close) close.setAttribute('aria-label', 'Cookie-Einstellungen schließen');

        const title = preferences.querySelector('.shopify-pc__prefs__intro h3');
        const intro = preferences.querySelector('.shopify-pc__prefs__intro p');
        const decline = document.getElementById('shopify-pc__prefs__header-decline');
        const descriptions = {
          'shopify-pc__prefs__essential': 'Diese Cookies sind für Anmeldung, Warenkorb, Checkout und grundlegende Shop-Funktionen erforderlich.',
          'shopify-pc__prefs__preferences': 'Diese Cookies merken sich Einstellungen und Inhalte, die zu deinem Besuch passen.',
          'shopify-pc__prefs__marketing': 'Diese Cookies helfen uns und unseren Partnern, einschließlich Shopify, Werbung und Marketing relevanter auszuspielen.',
          'shopify-pc__prefs__analytics': 'Diese Cookies zeigen uns, wie der Shop genutzt wird, damit wir Inhalte, Bedienung und Leistung verbessern können.'
        };

        if (title) title.textContent = 'Du entscheidest.';
        if (intro) intro.textContent = 'Wähle aus, welche Cookies du zulassen möchtest. Technisch notwendige Cookies bleiben immer aktiv.';
        if (decline) decline.textContent = 'Nur notwendige';

        Object.entries(descriptions).forEach(([id, copy]) => {
          const description = document.querySelector(`#${id} > p`);
          if (description) description.textContent = copy;
        });
      }
    }

    if (isGerman) {
      document.querySelectorAll('a[href*="id=GDPR_"]').forEach((link) => {
        if (link.textContent.trim() === 'Cookie Policy') link.textContent = 'Cookie-Einstellungen';
      });
    }

    syncBannerVisibility(banner);
  }

  function showPreferences(fallbackHref, attempts = 20) {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
      if (attempts > 0) {
        window.setTimeout(() => showPreferences(fallbackHref, attempts - 1), 100);
      } else if (fallbackHref) {
        window.location.assign(fallbackHref);
      }
      return;
    }

    window.privacyBanner.showPreferences()
      .then(() => {
        enhanceBanner();
        window.setTimeout(enhanceBanner, 50);
        window.setTimeout(enhanceBanner, 250);
      })
      .catch(() => {
        if (attempts > 0) {
          window.setTimeout(() => showPreferences(fallbackHref, attempts - 1), 100);
        } else if (fallbackHref) {
          window.location.assign(fallbackHref);
        }
      });
  }

  function visibleConsentSurface() {
    const preferences = document.getElementById('shopify-pc__prefs');
    if (preferences && window.getComputedStyle(preferences).display !== 'none' && preferences.getClientRects().length > 0) {
      return document.getElementById('shopify-pc__prefs__dialog') || preferences;
    }

    const banner = document.getElementById('shopify-pc__banner');
    if (banner && window.getComputedStyle(banner).display !== 'none' && banner.getClientRects().length > 0) {
      return banner;
    }

    return null;
  }

  function focusableConsentControls(surface) {
    return [...surface.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
      .filter((control) => {
        if (control.matches(':disabled') || control.getAttribute('aria-hidden') === 'true' || control.tabIndex < 0) return false;
        const style = window.getComputedStyle(control);
        return style.display !== 'none' && style.visibility !== 'hidden' && control.getClientRects().length > 0;
      });
  }

  function trapConsentFocus(event) {
    if (event.key !== 'Tab') return;

    const surface = visibleConsentSurface();
    if (!surface) return;

    const controls = focusableConsentControls(surface);
    if (controls.length === 0) return;

    const active = document.activeElement;
    const activeIndex = controls.indexOf(active);

    event.preventDefault();
    event.stopImmediatePropagation();

    if (activeIndex === -1) {
      controls[event.shiftKey ? controls.length - 1 : 0].focus();
      return;
    }

    const direction = event.shiftKey ? -1 : 1;
    const nextIndex = (activeIndex + direction + controls.length) % controls.length;
    controls[nextIndex].focus();
  }

  function handlePreferenceTrigger(event) {
    if (!(event.target instanceof Element)) return;

    const manage = event.target.closest('#shopify-pc__banner__btn-manage-prefs');
    if (manage) {
      // Shopify normally owns this click. The short fallback also covers a
      // fast first interaction while its preferences module is still loading.
      window.setTimeout(() => {
        const preferences = document.getElementById('shopify-pc__prefs');
        if (!preferences || window.getComputedStyle(preferences).display === 'none') {
          showPreferences();
        } else {
          enhanceBanner();
        }
      }, 80);
      return;
    }

    const trigger = event.target.closest('[data-asif-cookie-preferences], a[href*="id=GDPR_"]');
    if (!trigger) return;

    const fallbackHref = trigger.getAttribute('data-fallback-href') || trigger.getAttribute('href') || '';
    event.preventDefault();
    showPreferences(fallbackHref);
  }

  // Install the capture trap before banner enhancement can expose the
  // visible-state marker. This keeps the marker and keyboard readiness atomic.
  window.addEventListener('keydown', trapConsentFocus, true);
  enhanceBanner();

  // Shopify can replace the hidden banner node when it becomes visible. Keep
  // a lightweight document observer so the concise, equivalent copy and
  // labels also survive late rendering and later preference changes.
  const documentObserver = new MutationObserver(enhanceBanner);
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', handlePreferenceTrigger);
})();
